import React from 'react';
import { WAITLIST_COPY, WAITLIST_DEPOSIT } from '../../marketing/content/waitlist';
import ReservePlaceButton from './ReservePlaceButton';

interface WaitlistDepositBlockProps {
  entryRef: string;
  /** 'h1' where the block is the whole page (/waitlist/deposit); a plain line inside a form. */
  titleAs?: 'p' | 'h1';
}

/**
 * The deposit step: shown inline after a signup, and on /waitlist/deposit
 * after a popup signup. One component so the two can never drift apart.
 */
export default function WaitlistDepositBlock({ entryRef, titleAs: Title = 'p' }: WaitlistDepositBlockProps) {
  return (
    <div className="wl-pay" role="status" aria-live="polite">
      <p className="gh-eyebrow mb-3">{WAITLIST_COPY.onTheList}</p>
      <Title className="wl-pay__title">{WAITLIST_DEPOSIT.heading}</Title>
      <p className="wl-details__intro">{WAITLIST_DEPOSIT.terms}</p>
      <ReservePlaceButton entryRef={entryRef} />
      <p className="wl-help">{WAITLIST_DEPOSIT.processing}</p>
    </div>
  );
}
